export default __webpack_public_path__ + "static/media/Brocast-10-ban.a834a6e4.jpg";